import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const repRateServiceApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getIndependentReps: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchParams = '' } = args;
          return `${apiUrl.locationUserHistory}?perPage=${perPage || DEFAULT_PER_PAGE}&page=${
            page || DEFAULT_PAGE
          }&${searchParams}`;
        }
        return `${apiUrl.locationUserHistory}`;
      },
      // Return the raw response without transforming it
      transformResponse: (responseData) => responseData,
      providesTags: ['IndependentReps'],
    }),
    getIndependentRepsById: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage } = args;
          // Handle when args is a direct string/number
          if (typeof args === 'string' || typeof args === 'number') {
            return `${apiUrl.locationUserHistory}/${apiUrl.sublocation}?ids=${args}&page=${page}&perPage=${perPage}`;
          }

          // Handle when args contains searchParams like {searchParams: 'ids=12345'}
          if (args.searchParams) {
            // If searchParams already has the format 'ids=...'
            if (args.searchParams.startsWith('ids=')) {
              return `${apiUrl.locationUserHistory}/${apiUrl.sublocation}?${args.searchParams}&page=${page}&perPage=${perPage}`;
            }
            // Otherwise, use it as an ID directly
            return `${apiUrl.locationUserHistory}/${apiUrl.sublocation}?ids=${args.searchParams}&page=${page}&perPage=${perPage}`;
          }

          // Fallback to just using the args as-is
          return `${apiUrl.locationUserHistory}/${apiUrl.sublocation}?ids=${args}&page=${page}&perPage=${perPage}`;
        }
        return `${apiUrl.locationUserHistory}/${apiUrl.sublocation}`;
      },
      // Return the raw response without transforming it
      transformResponse: (responseData) => responseData,
      providesTags: ['IndependentReps'],
    }),
    createIndependentRep: build.mutation({
      query: (data) => ({
        url: `${apiUrl.locationUserHistory}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IndependentReps'],
    }),
    deleteIndependentRep: build.mutation({
      query: (data) => ({
        url: `${apiUrl.locationUserHistory}`,
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: ['IndependentReps'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetIndependentRepsQuery,
  useGetIndependentRepsByIdQuery,
  useCreateIndependentRepMutation,
  useDeleteIndependentRepMutation,
} = repRateServiceApi;
